import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Summary from '../Summary';
import SummaryTrials from '../SummaryTrials';
import SummaryStudents from '../SummaryStudents';

export const I18nPrefix = 'strava.subscriptions.checkout.summary.trial';

const SummaryContainer = ({ isTrial, isStudentPromotion }) => {
  let content;
  // render student summary if isStudentPromotion === true regardless of trial status
  if (isTrial && !isStudentPromotion) {
    content = <SummaryTrials />;
  } else if (isStudentPromotion) {
    content = <SummaryStudents />;
  } else {
    content = <Summary />;
  }

  return content;
};

SummaryContainer.propTypes = {
  isTrial: PropTypes.bool.isRequired,
  isStudentPromotion: PropTypes.bool
};

SummaryContainer.defaultProps = {
  isTrial: false,
  isStudentPromotion: false
};

const mapStateToProps = (state) => {
  return {
    isTrial: state.isTrial,
    isStudentPromotion: state.isStudentPromotion
  };
};

export default connect(mapStateToProps)(SummaryContainer);
